import { EtablissementCardDto } from '@common/services';
import { EtablissementCard } from '@common/ui/etablissement';
import React from 'react';
import './etablissement-declarant.css';

export const EtablissementDeclarantConsolidesCard = ({
                                                       declarant,
                                                       consolides,
                                                       onEdit,
                                                       onDelete,
                                                     }: EtablissementDeclarantConsolidesProps) => {
  return (
    <div className={'flex flex-col'}>
      {(!!declarant) && (
        <EtablissementCard etablissement={declarant} onEdit={onEdit} onDelete={onDelete} />
      )}

      {(!!consolides && consolides.length > 0) && (
        <div className={'flex flex-col'}>
          {consolides.map((consolide, index) => (
            <div className={'relative pr-4 pl-15'} key={index}>
              <div className={`consolidee-line`}>
                <div className={(index !== (consolides.length - 1)) ? 'next-consolidee-line' : ''}></div>
                <div className={`p-1 ${index === 0 ? 'pt-2' : ''}`}>
                  <EtablissementCard etablissement={consolide} onEdit={onEdit} onDelete={onDelete} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

interface EtablissementDeclarantConsolidesProps extends EtablissementDeclarantConsolides {
  onEdit?: (etablissementId: number) => void;
  onDelete?: (etablissementId: number, denominationUsuelle: string) => void;
}

export interface EtablissementDeclarantConsolides {
  declarant?: EtablissementCardDto;
  consolides?: EtablissementCardDto[];
}